import React from "react";
import { useSelector } from 'react-redux';
import { authSelector } from '../../features/auth/authSlice';
import { RootState } from '../../store/store';
import { getRagChatName } from '../../utils/ragConfig';

// Accept mode as a prop, fallback to prefers-color-scheme if not provided
// overrideText: when provided, replaces the auto-generated greeting entirely (e.g., for the RAG selector page)
export function Greeting({ mode, overrideText }: { mode?: 'light' | 'dark'; overrideText?: string }) {
  const auth = useSelector(authSelector);
  const chatModeState = useSelector((state: RootState) => state.chatMode);
  const userName = (auth.profile?.account?.name || auth.profile?.account?.username || "").split(' ')[0];

  // Build the greeting title based on current chat mode / RAG type.
  // Only use ragChatType when actually in 3M Knowledge mode — it is preserved
  // across mode switches as memory but should not affect the Ask Chat greeting.
  const ragChatType = chatModeState.mode === '3M Knowledge' ? chatModeState.ragChatType : null;
  const chatName = getRagChatName(ragChatType)
    ? (ragChatType === 'HR' ? `${getRagChatName(ragChatType)}` : `3M Navigator ${getRagChatName(ragChatType)}`)
    : '3M Navigator';
  const greetingText = overrideText ?? `Welcome to ${chatName}!`;

  // Mode-aware text shadow for greeting: subtle dark shadow in dark mode, soft glow in light mode
  let resolvedMode = mode;
  if (!resolvedMode) {
    if (typeof window !== 'undefined' && window.matchMedia) {
      resolvedMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    } else {
      resolvedMode = 'light';
    }
  }

  return (
    <div
      className="flex flex-col items-center gap-2 w-full justify-center"
      style={{ marginBottom: window.innerWidth < 1400 ? '8px' : '16px' }}
    >
  <span className="font-medium drop-shadow-md text-[var(--color-text)] mt-[3px] ml-[5px] relative" style={{ fontSize: 'clamp(.75rem, 1.3vw, 1.15rem)' }}>
        {overrideText ? greetingText : `Hi ${userName}, ${greetingText}`}
        {/* Glassy highlight underline only in light mode */}
        {resolvedMode === 'light' && (
          <span
            style={{
              display: 'block',
              position: 'absolute',
              left: '10%',
              right: '10%',
              bottom: '-3px',
              height: '3px',
              borderRadius: '2px',
              background: 'linear-gradient(90deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.38) 50%, rgba(255,255,255,0.22) 100%)',
              opacity: 0.7,
              pointerEvents: 'none',
            }}
          />
        )}
      </span>
    </div>
  );
}